import { useFormContext } from 'react-hook-form';
import { QRCodeStepper } from '../../QRCodeStepper';
import { QRCodeFormSchema } from '@app/domain/qr-code/api/qr-code.form.schema.api';
import { useState } from 'react';
import { WIFISetup } from './WIFISetup';
import { TranslationKey } from '@app/locales/defaultTranslation';
import { QRCodeHeaderEditor } from '../../QRCodeHeaderEditor';

const wifiSteps: TranslationKey[] = ['qr.wifiInput.setupTab', 'qr.wifiInput.headerTab'];

export const QRCodeWIFI: React.FC<{
  forWidgetMode?: boolean;
  disabledEditInput?: boolean;
  isEditMode?: boolean;
}> = ({ forWidgetMode, disabledEditInput }) => {
  const [activeStep, setActiveStep] = useState(0);
  const { trigger } = useFormContext<QRCodeFormSchema>();

  return (
    <div className="flex flex-col gap-4">
      <QRCodeStepper
        steps={wifiSteps}
        activeStep={activeStep}
        setActiveStep={async (nextStep) => {
          const isSSIDValid = await trigger('wifi.ssid', { shouldFocus: true });
          const isTitleValid = await trigger('wifi.title', { shouldFocus: true });
          if (isSSIDValid || isTitleValid) {
            setActiveStep(() => nextStep);
          }
        }}
      />

      {!activeStep ? (
        <WIFISetup />
      ) : (
        <QRCodeHeaderEditor prefix="wifi" forWidgetMode={forWidgetMode} disabledEditInput={disabledEditInput} />
      )}
    </div>
  );
};
